function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M-804-566h1920v2651H-804z"
}), React.createElement("path", {
  d: "M-805-259h1920v2286H-805z"
}), React.createElement("g", {
  transform: "translate(-69.5 -52)"
}, React.createElement("path", {
  fill: "currentColor",
  d: "M106.094 61.053c15.101 0 27.344 12.243 27.344 27.344 0 15.102-12.243 27.344-27.344 27.344-15.102 0-27.344-12.242-27.344-27.344 0-15.101 12.242-27.344 27.344-27.344zm0 2.188c-13.894 0-25.156 11.263-25.156 25.156 0 13.894 11.262 25.156 25.156 25.156 13.893 0 25.156-11.262 25.156-25.156 0-13.893-11.263-25.156-25.156-25.156zM117.03 77.46v4.375h2.188v8.75h-4.376v6.562h-2.187v4.375h-4.375v-4.375h-2.187v-6.562H90.78v-3.282h-4.375V85.15h4.375v-3.314h19.687V77.46h6.563zm-4.375 13.125h-4.375v4.375h4.375v-4.375zm4.375-6.563H92.97v4.375h24.062v-4.375zm-2.187-4.375h-2.188v2.188h2.188v-2.188z"
})), React.createElement("text", {
  fontFamily: "BNPPSans, BNPP Sans",
  fontSize: 16,
  transform: "translate(-69.5 -56.72)"
}, React.createElement("tspan", {
  x: 35.504,
  y: 138.719
}, "Pistolet spryskuj\u0105cy")));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 71,
    height: 71
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/raingun.420d9f46.svg";
export { SvgComponent as ReactComponent };